import { jsxs as o, jsx as a, Fragment as h } from "react/jsx-runtime";
import * as c from "react";
import { memo as N } from "react";
import { Tag as C } from "antd";
import { I as s } from "./AntdIcon-DR2yozD3.js";
import { R as I } from "./CloseCircleFilled-PXbhInq_.js";
var j = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" } }] }, name: "check-circle", theme: "filled" };
function l() {
  return l = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var e in r)
        Object.prototype.hasOwnProperty.call(r, e) && (n[e] = r[e]);
    }
    return n;
  }, l.apply(this, arguments);
}
const w = (n, t) => /* @__PURE__ */ c.createElement(s, l({}, n, {
  ref: t,
  icon: j
})), i = /* @__PURE__ */ c.forwardRef(w);
process.env.NODE_ENV !== "production" && (i.displayName = "CheckCircleFilled");
var z = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "defs", attrs: {}, children: [{ tag: "style", attrs: {} }] }, { tag: "path", attrs: { d: "M945 412H689c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h256c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM811 548H689c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h122c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM477.3 322.5H434c-6.2 0-11.2 5-11.2 11.2v248c0 3.6 1.7 6.9 4.6 9l148.9 108.6c5 3.6 12 2.6 15.6-2.4l25.7-35.1v-.1c3.6-5 2.5-12-2.5-15.6l-126.7-91.6V333.7c.1-6.2-5-11.2-11.1-11.2z" } }, { tag: "path", attrs: { d: "M804.8 673.9H747c-5.6 0-10.9 2.9-13.9 7.7a321 321 0 01-44.5 55.7 317.17 317.17 0 01-101.3 68.3c-39.3 16.6-81 25-124 25-43.1 0-84.8-8.4-124-25-37.9-16-72-39-101.3-68.3s-52.3-63.4-68.3-101.3c-16.6-39.2-25-80.9-25-124 0-43.1 8.4-84.7 25-124 16-37.9 39-72 68.3-101.3 29.3-29.3 63.4-52.3 101.3-68.3 39.2-16.6 81-25 124-25 43.1 0 84.8 8.4 124 25 37.9 16 72 39 101.3 68.3a321 321 0 0144.5 55.7c3 4.8 8.3 7.7 13.9 7.7h57.8c6.9 0 11.3-7.2 8.2-13.3-65.2-129.7-197.4-214-345-215.7-216.1-2.7-395.6 174.2-396 390.1C71.6 727.5 246.9 903 463.2 903c149.5 0 283.9-84.6 349.8-215.8a9.18 9.18 0 00-8.2-13.3z" } }] }, name: "field-time", theme: "outlined" };
function f() {
  return f = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var e in r)
        Object.prototype.hasOwnProperty.call(r, e) && (n[e] = r[e]);
    }
    return n;
  }, f.apply(this, arguments);
}
const $ = (n, t) => /* @__PURE__ */ c.createElement(s, f({}, n, {
  ref: t,
  icon: z
})), v = /* @__PURE__ */ c.forwardRef($);
process.env.NODE_ENV !== "production" && (v.displayName = "FieldTimeOutlined");
var E = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { tag: "path", attrs: { d: "M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, name: "question-circle", theme: "outlined" };
function u() {
  return u = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var e in r)
        Object.prototype.hasOwnProperty.call(r, e) && (n[e] = r[e]);
    }
    return n;
  }, u.apply(this, arguments);
}
const R = (n, t) => /* @__PURE__ */ c.createElement(s, u({}, n, {
  ref: t,
  icon: E
})), b = /* @__PURE__ */ c.forwardRef(R);
process.env.NODE_ENV !== "production" && (b.displayName = "QuestionCircleOutlined");
var y = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M464 720a48 48 0 1096 0 48 48 0 10-96 0zm16-304v184c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8zm475.7 440l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-783.5-27.9L512 239.9l339.8 588.2H172.2z" } }] }, name: "warning", theme: "outlined" };
function d() {
  return d = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var e in r)
        Object.prototype.hasOwnProperty.call(r, e) && (n[e] = r[e]);
    }
    return n;
  }, d.apply(this, arguments);
}
const M = (n, t) => /* @__PURE__ */ c.createElement(s, d({}, n, {
  ref: t,
  icon: y
})), O = /* @__PURE__ */ c.forwardRef(M);
process.env.NODE_ENV !== "production" && (O.displayName = "WarningOutlined");
const _ = ({
  record: n,
  type: t = "text"
}) => {
  const { stock_status: r, stock_quantity: e, low_stock_amount: x = 0 } = n;
  if (!r) return null;
  const { label: m, color: g, Icon: p } = P(
    r,
    e,
    x
  );
  return t === "tag" ? /* @__PURE__ */ o(C, { bordered: !1, className: `at-m-0 ${g}`, icon: /* @__PURE__ */ a(p, {}), children: [
    m,
    Number.isInteger(e) && /* @__PURE__ */ o(h, { children: [
      " (",
      e,
      ")"
    ] })
  ] }) : /* @__PURE__ */ o("p", { className: "at-m-0 at-text-gray-500 at-text-xs", children: [
    /* @__PURE__ */ a(p, { className: `at-mr-2 ${g}` }),
    m,
    Number.isInteger(e) && /* @__PURE__ */ o(h, { children: [
      " (",
      e,
      ")"
    ] })
  ] });
}, D = N(
  _
);
function P(n, t, r) {
  switch (n) {
    case "instock":
      return t === null || r === null ? {
        label: "尚有庫存",
        color: "text-green-500",
        Icon: ({ ...e }) => /* @__PURE__ */ a(i, { ...e })
      } : t > r ? {
        label: "庫存充足",
        color: "text-green-500",
        Icon: ({ ...e }) => /* @__PURE__ */ a(i, { ...e })
      } : {
        label: "低庫存",
        color: "text-orange-500",
        Icon: ({ ...e }) => /* @__PURE__ */ a(O, { ...e })
      };
    case "outofstock":
      return {
        label: "缺貨中",
        color: "text-red-500",
        Icon: ({ ...e }) => /* @__PURE__ */ a(I, { ...e })
      };
    case "onbackorder":
      return {
        label: "延期交貨(預購)",
        color: "text-purple-500",
        Icon: ({ ...e }) => /* @__PURE__ */ a(v, { ...e })
      };
    default:
      return {
        label: "庫存狀態未知",
        color: "text-gray-500",
        Icon: ({ ...e }) => /* @__PURE__ */ a(b, { ...e })
      };
  }
}
export {
  D as P,
  i as R
};
